export const siteName = 'Byt.E-业务&财务管理系统'

// 社保类型枚举(insuranceType)
export const insuranceTypeData = [
  { id: 'ins-annuity', name: 'annuity', desc: '养老' },
  { id: 'ins-medical', name: 'medical', desc: '医疗' },
  { id: 'ins-unemployment', name: 'unemployment', desc: '失业' },
  { id: 'ins-injury', name: 'injury', desc: '工伤' },
  { id: 'ins-birth', name: 'birth', desc: '生育' },
  { id: 'ins-critical-illness', name: 'critical-illness', desc: '大病' },
  { id: 'ins-provident', name: 'provident', desc: '公积金' },
  { id: 'ins-supplement-provident', name: 'supplement-provident', desc: '补充公积金' }
]

// 社保类型枚举(insuranceType)
export const medicalPeriod = [
  { id: 'everytime', name: 'everytime', desc: '次' },
  { id: 'yearly', name: 'yearly', desc: '年' }
]

// 区域
export const regionData = [
  { id: 'worldwide', name: '全球' },
  { id: 'worldwide-except-us', name: '全球除美' },
  { id: 'asia-pacific', name: '亚太' },
  { id: 'greater-china', name: '大中华' },
  { id: 'mainland-china', name: '国内' }
]

// 保险数据
export const channelData = [
  { id: 'offline', name: '线下' },
  { id: 'online', name: '网销' },
  { id: 'offline-online', name: '线下和网销' }
]

// 产品周期
export const periodData = [
  { id: 'regular', name: '定期型' },
  { id: 'lifetime', name: '终身型' },
  { id: 'regular-or-lifetime', name: '终身型或定期型' }
]

// 消费或储蓄型
export const valueData = [
  { id: 'consumption', name: '消费型' },
  { id: 'savings', name: '储蓄型' }
]

// 平台
export const btData = {
  income: { key: 'baotongIncome', name: '保通 收入明细' },
  order: { key: 'baotongOrder', name: '保通 保单列表' },
  continue: { key: 'baotongContinue', name: '保通 续保订单' }
}

export const qxData = {
  order: { key: 'qixinOrder', name: '齐欣 业务' },
  fees: { key: 'qixinFees', name: '齐欣 服务费' },
  continue: { key: 'qixinContinue', name: '齐欣 续保订单' }
}

export const nyData = {
  income: { key: 'nanyanIncome', name: '南燕 保单积分' }
}

export const bhbData = {
  order: { key: 'bohebaoOrder', name: '薄荷保 订单明细' }
}

export const wtsData = {
  order: { key: 'wutongshuOrder', name: '梧桐树 新单' },
  continue: { key: 'wuthongshuContinue', name: '梧桐树 续保' }
}

export const xysData = {
  order: { key: 'umbrellaOrder', name: '小雨伞 新单' },
  continue: { key: 'umbrellaContinue', name: '小雨伞 续保' }
}

export const yyData = {
  order: { key: 'yingyuOrder', name: '鹰宇 新单' }
}

export const channelKeyData = {
  [btData.income.key]: btData.income.name,
  [btData.order.key]: btData.order.name,
  [btData.continue.key]: btData.continue.name,
  [qxData.order.key]: qxData.order.name,
  [qxData.fees.key]: qxData.fees.name,
  [qxData.continue.key]: qxData.continue.name,
  [nyData.income.key]: nyData.income.name,
  [bhbData.order.key]: bhbData.order.name,
  [wtsData.order.key]: wtsData.order.name,
  [wtsData.continue.key]: wtsData.continue.name,
  [xysData.order.key]: xysData.order.name,
  [xysData.continue.key]: xysData.continue.name,
  [yyData.order.key]: yyData.order.name
}

export const channelAllData = [
  { ...btData.income },
  { ...btData.order },
  { ...btData.continue },
  { ...qxData.order },
  { ...qxData.fees },
  { ...qxData.continue },
  { ...nyData.income },
  { ...bhbData.order },
  { ...wtsData.order },
  { ...wtsData.continue },
  { ...xysData.order },
  { ...xysData.continue },
  { ...yyData.order }
]
